var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 59,
    viewBox: "0 0 55 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5926 6.52271C10.1481 6.96715 10 7.70789 10 8.59678V41.3375C10 42.2264 10.2963 42.9672 10.7407 43.4116L10.8889 43.5597L29.2593 25.1894V24.8931L10.5926 6.52271Z",
    fill: "url(#paint0_linear_5_3127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1852 31.4117L29.1111 25.3376V24.8932L35.1852 18.8191L35.3333 18.9672L42.5926 23.1154C44.6667 24.3006 44.6667 26.2265 42.5926 27.4117L35.1852 31.4117Z",
    fill: "url(#paint1_linear_5_3127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3333 31.2635L29.1111 25.0413L10.5926 43.5598C11.3333 44.3005 12.3704 44.3005 13.7037 43.7079L35.3333 31.2635Z",
    fill: "url(#paint2_linear_5_3127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3333 18.8189L13.7037 6.52265C12.3704 5.7819 11.3333 5.93005 10.5926 6.67079L29.1111 25.0412L35.3333 18.8189Z",
    fill: "url(#paint3_linear_5_3127)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.1852 31.1152L13.7037 43.2634C12.5185 44.0041 11.4815 43.856 10.7407 43.2634L10.5926 43.4115L10.7407 43.5597C11.4815 44.1523 12.5185 44.3004 13.7037 43.5597L35.1852 31.1152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M10.5926 43.2635C10.1481 42.819 10 42.0783 10 41.1894V41.3376C10 42.2264 10.2963 42.9672 10.7407 43.4116V43.2635H10.5926ZM42.5926 26.9672L35.1852 31.1153L35.3333 31.2635L42.5926 27.1153C43.6296 26.5227 44.0741 25.782 44.0741 25.0413C44.0741 25.782 43.4815 26.3746 42.5926 26.9672Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M13.7037 6.67083L42.5926 23.1153C43.4815 23.7079 44.0741 24.3005 44.0741 25.0412C44.0741 24.3005 43.6296 23.5597 42.5926 22.9671L13.7037 6.52268C11.6296 5.3375 10 6.22638 10 8.59675V8.7449C10 6.52268 11.6296 5.48564 13.7037 6.67083Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_3127",
    x: -0.0000038147,
    y: 0,
    width: 54.1481,
    height: 58.1355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_3127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_3127",
    x1: 27.4815,
    y1: 8.3153,
    x2: 2.61777,
    y2: 33.1775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_3127",
    x1: 45.3096,
    y1: 25.0428,
    x2: 9.4622,
    y2: 25.0428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_3127",
    x1: 31.9659,
    y1: 28.4427,
    x2: -1.74963,
    y2: 62.1583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_3127",
    x1: 5.99555,
    y1: -4.32773,
    x2: 21.0518,
    y2: 10.7286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/AndroidIcon.013cfef0c85f0bb964120586f0aabc73.svg";
export { ForwardRef as ReactComponent };